const accordionTitle = document.querySelectorAll(".product-accordion__title");
const accordionItem = document.querySelectorAll(
  ".product-accordion__container"
);
accordionTitle.forEach((list, index) => {
  list.addEventListener("click", () => {
    list.classList.toggle("open");
    accordionItem[index].classList.toggle("open");
  });
});

let swiperbool;
const breakPoint = 749;

window.addEventListener(
  "load",
  () => {
    if (breakPoint < window.innerWidth) {
      swiperbool = false;
    } else {
      createSwiper();
      swiperbool = true;
    }
  },
  false
);

window.addEventListener(
  "resize",
  () => {
    if (breakPoint < window.innerWidth && swiperbool) {
      swiperbool = false;
    } else if (breakPoint >= window.innerWidth && !swiperbool) {
      createSwiper();
      swiperbool = true;
    }
  },
  false
);

const createSwiper = () => {
  mySwiper = new Swiper(".product-accordion__container", {
    loop: false,
    slidesPerView: 1.2,
    spaceBetween: 20,
  });
};
